import { useHistory } from "react-router-dom";
import { useCallback } from "react";

export function useRedirect(redirectUrl: string) {
  const history = useHistory();
  return useCallback(() => history.push(redirectUrl), [history, redirectUrl]);
}
